import { explain } from "@/lib/explanations";

// Always-visible, muted one-line description under a panel heading. The board
// reads it directly — it is NOT hover-only. Pass either a known key from the
// bilingual explanation texts (`k`) or a literal string (`text`); `k` wins if
// both are given. Follows the active dashboard language.
export function PanelHelp({ k, text }: { k?: string; text?: string }) {
  const copy = (k && explain(k)) || text || "";
  if (!copy) return null;
  return <p class="panel-help">{copy}</p>;
}

// Tiny inline "ⓘ" marker for an individual non-obvious metric. The explanation
// shows as a native browser tooltip (title=) — dependency-free, keyboard- and
// screen-reader-reachable via the button element. Pass a key or literal text.
export function InfoDot({ k, text }: { k?: string; text?: string }) {
  const copy = (k && explain(k)) || text || "";
  if (!copy) return null;
  return (
    <button type="button" class="info-dot" title={copy} aria-label={copy}>
      ⓘ
    </button>
  );
}
